module.exports = __webpack_public_path__ + "static/img/notice.35d81af8.png";